import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { API } from 'aws-amplify';

const ListUsers = () => {
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(false);

    const getUsers = async (search) => {
        if (search.length > 0) {
            setLoading(true);
            API.get('IntvAPI', 'admin/users?search=' + encodeURIComponent(search))
            .then(response => {
                setUserList(response.users);
                setLoading(false);
            })
            .catch(error => {
                console.error(error);
                setLoading(false);
            })
        }
        else {
            setUserList([]);
        }
    }

    return <>
        <input type="text" placeholder="user.email@abc.com" onChange={e => getUsers(e.target.value)}/>
        {loading &&<>loading...</>}
        <ul>
            {userList.map(user => <li key={user.id}><Link to={`/admin/users/${user.id}`}>{user.email}</Link></li>)}
        </ul>
    </>
}

export default ListUsers;